import { useCreateProjectMutation, useDebouncedSearch } from '@consigli/hooks';
import { Button } from '@consigli/shadcn';
import { CreateProjectRequest } from '@consigli/types';
import { useCallback, useState } from 'react';
import { HiOutlinePlusSm } from 'react-icons/hi';

import { PageHeader } from '@/components/page-header';
import { errorToast, successToast } from '@/components/toast';

import { ProjectFiltersComponent } from './projects-filter/project-filters';
import { ProjectForm } from './projects-form/project-form';
import { ProjectsTable } from './projects-table/projects-table';
import { ProjectFilters } from './types';

export const ProjectsPage = () => {
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState<ProjectFilters>({
    organization: [],
  });

  const [createProject] = useCreateProjectMutation();

  const debouncedSearchTerm = useDebouncedSearch(searchTerm, 500);
  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setPage(1);
    setSearchTerm(e.target.value);
  }, []);

  const handleFiltersChange = useCallback((newFilters: ProjectFilters) => {
    setPage(1);
    setFilters(newFilters);
  }, []);

  const handleCreateProject = async (projectData: CreateProjectRequest) => {
    try {
      await createProject(projectData).unwrap();
      successToast({ message: 'Project created successfully!' });
    } catch (error: unknown) {
      console.error('Failed to create project:', error);
      errorToast({ message: 'Failed to create project. Please try again.' });
      throw error; // Re-throw to let the modal handle the error
    }
  };

  return (
    <>
      <PageHeader title="Projects">
        <ProjectFiltersComponent
          searchTerm={searchTerm}
          handleSearch={handleSearch}
          onFiltersChange={handleFiltersChange}
        />
        <ProjectForm
          onSubmit={handleCreateProject}
          isSubmitting={false}
          onCancel={() => {}}
          onFormChange={() => {}}
          trigger={
            <Button>
              Add Project
              <HiOutlinePlusSm />
            </Button>
          }
        />
      </PageHeader>
      <ProjectsTable
        page={page}
        setPage={setPage}
        debouncedSearchTerm={debouncedSearchTerm}
        filters={filters}
      />
    </>
  );
};
